import {
  type FocusEventHandler,
  type KeyboardEventHandler,
  useState,
} from 'react'
import styled from 'styled-components'

import Close from '~/shared/assets/icons/Close'
import theme from '~/shared/styles/theme'

interface Props {
  genreTags: string[]
  setGenreTags: (tags: string[]) => void
}

export default function GenreTag({ genreTags, setGenreTags }: Props) {
  const [tagInput, setTagInput] = useState('')

  const addTagsByKeyboard: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'Enter') {
      const filtered = genreTags.filter((el) => el === tagInput)

      if (tagInput !== '' && filtered.length === 0) {
        setGenreTags([...genreTags, tagInput])
        setTagInput('')
      }
    }
  }

  const addTagsByMobile: FocusEventHandler<HTMLInputElement> = () => {
    const filtered = genreTags.filter((el) => el === tagInput)

    if (tagInput !== '' && filtered.length === 0) {
      setGenreTags([...genreTags, tagInput])
      setTagInput('')
    }
  }

  const removeTags = (indexToRemove: number) => {
    setGenreTags(genreTags.filter((_, index) => index !== indexToRemove))
  }

  return (
    <TagContainer>
      <input
        className="tag-input text-input"
        type="text"
        value={tagInput}
        onChange={(e) => setTagInput(e.target.value)}
        onKeyUp={addTagsByKeyboard}
        onBlur={addTagsByMobile}
        placeholder="태그 입력"
      />
      <ul id="tags">
        {genreTags &&
          genreTags.map((tag, index) => (
            <li key={index} className="tag">
              <span className="tag-title">{tag}</span>
              <Close onClick={() => removeTags(index)} width={21} height={21} />
            </li>
          ))}
      </ul>
    </TagContainer>
  )
}

const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 15px;

  > ul {
    display: flex;
    flex-wrap: wrap;

    > .tag {
      cursor: pointer;

      display: flex;
      gap: 10px;
      align-items: center;
      justify-content: center;

      box-sizing: border-box;
      width: fit-content;
      height: 49px;
      margin-top: 10px;
      margin-right: 20px;
      padding: 12px 20px;

      list-style: none;

      background: ${theme.colors.grey_2};
      border-radius: 12px;
    }
  }

  > input {
    height: 49px;
    font-size: 15px;
    border: none;

    :focus {
      outline: transparent;
    }
  }
`
